/**
 * Light/dark toggle for the public pages (Home, Login). Presentational only —
 * callers own the useTheme() call so the page can also react to the current
 * theme itself (e.g. picking a framer-motion hover color). Tailwind-styled,
 * so it only belongs on pages that load ../landing.css.
 */
import type { Theme } from "../hooks/useTheme";

export function ThemeToggle({ theme, onToggle }: { theme: Theme; onToggle: () => void }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      className="tw:w-11 tw:h-11 tw:shrink-0 tw:rounded-full tw:bg-white tw:dark:bg-[#171a21] tw:border tw:border-transparent tw:dark:border-[#2a2f3a] tw:shadow-md tw:flex tw:items-center tw:justify-center tw:text-lg tw:leading-none tw:text-neutral-700 tw:dark:text-[#e6e8ee] tw:cursor-pointer"
    >
      {/* U+FE0E forces monochrome "text" glyph presentation — without it,
          the sun (unlike the moon) renders as a full-color emoji on most
          platforms, breaking the button's flat, single-color look. */}
      {theme === "dark" ? "☀︎" : "☾︎"}
    </button>
  );
}
